import { CALL_API, Schemas } from '../../../common/middleware/api';

export const PARENTS_NOT_CHOOSE_CENTER_REQUEST = 'PARENTS_NOT_CHOOSE_CENTER_REQUEST';
export const PARENTS_NOT_CHOOSE_CENTER_SUCCESS = 'PARENTS_NOT_CHOOSE_CENTER_SUCCESS';
export const PARENTS_NOT_CHOOSE_CENTER_FAILURE = 'PARENTS_NOT_CHOOSE_CENTER_FAILURE';

export const loadParentsNotChooseCenter = (options) => ({
	[CALL_API]: {
		types: [PARENTS_NOT_CHOOSE_CENTER_REQUEST, PARENTS_NOT_CHOOSE_CENTER_SUCCESS, PARENTS_NOT_CHOOSE_CENTER_FAILURE],
		endpoint: 'api/reports/parents/notChosenCenter',
		request: options,
		schema: Schemas.PARENTS_NOT_CHOOSE_CENTER_ARRAY
	}
});